export default {
  title: 'Theme Flow Guide',
  mindMap: 'Mind Map',
  documentTitle: '{name} Theme Flow Guide',
  introduction: 'This document lists all scene completion conditions, their AND/OR relationships, and completion actions. Actions appear in action bar order, including every delay, parameter and action description.',
  task: 'Task {id}',
  mainTask: 'Main Task',
  unassignedScenes: 'Scenes without a task',
  scene: 'Scene {id}',
  unnamedScene: 'Unnamed scene',
  sceneDescription: 'Scene description: {description}',
  nextScenes: 'Next scenes: {scenes}',
  sceneTiming: 'Check delay after entry: {delay} seconds; Timeout: {timeout} seconds; Auto-skip on timeout: {skip}',
  yes: 'Yes',
  no: 'No',
  none: 'None',
  and: 'AND',
  or: 'OR',
  notConfigured: 'Not configured',
  noCondition: 'No condition configured',
  noConditionGroup: 'No condition group configured',
  noPassCondition: 'No completion conditions configured',
  noPassConditionSentence: 'No completion conditions configured.',
  noAction: 'No actions configured',
  noActionSentence: 'No actions configured.',
  noPassAction: 'No completion actions configured',
  noPassActionSentence: 'No completion actions configured.',
  passConditions: 'Completion conditions',
  passCheck: 'Completion check',
  passActions: 'Completion actions',
  action: 'Action',
  actionBar: 'Action bar',
  conditionalAction: 'Conditional action',
  conditionalPassAction: 'Conditional completion action',
  trueActionBar: 'Action bar when condition is met',
  falseActionBar: 'Action bar when condition is not met',
  conditionMet: 'Condition met',
  conditionNotMet: 'Condition not met',
  executionCondition: 'Execution condition: {condition}',
  condition: 'Condition {id}: {condition}',
  nextConditionRelation: '; {relation} with the next condition',
  delay: ' (delay {seconds} seconds)',
  colon: ': ',
  comma: ', ',
  semicolon: '; ',
  actionSeparator: ', ',
  parentheses: ' ({text})',
  quote: '“{text}”',
  conditionText: '{device} {operation}',
  operationParameter: '{operation} {parameter}',
  deviceAction: '“{device}” {operation}',
  unknownDevice: 'Unknown device',
  unknownAction: 'Unknown action',
  unknownCondition: 'Unknown condition: {condition}',
  emptyCondition: 'Empty condition',
  specifiedState: 'Reaches the specified state',
  targetScene: 'Target scene “{name}” (Scene {id})',
  parameterValue: 'Parameter value',
  brightness: 'Brightness',
  volume: 'Volume',
  priority: 'Priority',
  namedParameter: '{name}: “{value}”',
  additionalParameter: 'Additional parameter: “{value}”',
  parameterTarget: 'Parameter target ID: “{value}”',
  parameterHint: 'Parameter hint: “{hint}”',
  priorityHint: 'Higher values mean higher priority',
  languageHint: '0 Default, 1 Chinese, 2 Cantonese, 3 English, 4 Japanese, 5 Korean',
  actionDescription: '; Action description: “{description}”',
  nextSceneDescription: 'Next scene',
  noScenes: 'The current theme has no scenes to export',
  waitForScenes: 'No scenes to export. Please wait for the theme data to finish loading.',
  wordExported: 'Theme flow Word document exported',
  xmindExported: 'Theme flow mind map exported',
  exportFailed: 'Failed to export the theme flow. Please try again later.',
}
